/* eslint-disable linebreak-style */
import Immutable from 'seamless-immutable';
import { SET_SHARED_ENTITLEMENTS_CURRENT_PAGE, SET_SHARED_ENTITLEMENTS_PAGE_SIZE } from '../actions/shared.entitlements.actions';
export var INITIAL_STATE = Immutable({
  pageNumber: 1,
  pageSize: 25
});
export default function SharedEntitlementsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_SHARED_ENTITLEMENTS_PAGE_SIZE:
      return state.set('pageSize', payload);
    case SET_SHARED_ENTITLEMENTS_CURRENT_PAGE:
      return state.set('pageNumber', payload);
    default:
      return state;
  }
}